import type {Recruitment} from '../../../../core/entities/recruitment/schema';
import {cn} from '../../../../lib/classname';
import {CardForPc} from '../../../recruitingInfo/components/Container/Presenter/CardForPc';
import {CardForSp} from '../../../recruitingInfo/components/Container/Presenter/CardForSp';

export const RecruitmentList: React.FC<{
  title: string;
  recruitments: Recruitment[];
  isGrid?: boolean;
  hasTargetYear?: boolean;
}> = ({title, recruitments, isGrid = false, hasTargetYear = true}) => {
  if (recruitments.length === 0) {
    return null;
  }
  return (
    <div className="w-full mt-16">
      <div className="bg-white p-16 rounded-t-16">
        <h2 className="font-bold">{title}</h2>
      </div>
      <div
        className={cn(
          'hidden pc:mt-8',
          isGrid
            ? 'pc:grid pc:grid-cols-2 pc:gap-8'
            : 'pc:flex pc:flex-col pc:gap-8',
        )}
      >
        {recruitments.map((recruitment) => (
          <div key={recruitment.id}>
            <CardForPc
              recruitment={recruitment}
              hasTargetYear={hasTargetYear}
            />
          </div>
        ))}
      </div>
      <div className="pc:hidden gap-8 mt-8">
        {recruitments.map((recruitment) => (
          <CardForSp key={recruitment.id} recruitment={recruitment} />
        ))}
      </div>
    </div>
  );
};
